import request from './request';

/**
 * 评分模板API
 */

// 获取评估目标列表
export function getEvalTargets() {
  return request({
    url: '/eval/score-templates/eval-targets',
    method: 'get'
  });
}

// 获取评分模板列表
export function getScoreTemplates(params) {
  return request({
    url: '/eval/score-templates',
    method: 'get',
    params
  });
}

// 获取默认模板（可按评估目标筛选）
export function getDefaultTemplate(evalTarget = null) {
  return request({
    url: '/eval/score-templates/default',
    method: 'get',
    params: evalTarget ? { eval_target: evalTarget } : {}
  });
}

// 获取模板详情
export function getScoreTemplateDetail(id) {
  return request({
    url: `/eval/score-templates/${id}`,
    method: 'get'
  });
}

// 创建评分模板
export function createScoreTemplate(data) {
  return request({
    url: '/eval/score-templates',
    method: 'post',
    data
  });
}

// 更新评分模板
export function updateScoreTemplate(id, data) {
  return request({
    url: `/eval/score-templates/${id}`,
    method: 'put',
    data
  });
}

// 删除评分模板
export function deleteScoreTemplate(id) {
  return request({
    url: `/eval/score-templates/${id}`,
    method: 'delete'
  });
}

